import styled from 'styled-components'
import { colors } from '../../theme'

/**
 * Acoes por linha da aba "Clientes por potencial".
 *
 * Sao ancoras estilizadas como botao, e nao <button> com navigate(): a aba e uma FILA DE TRABALHO
 * (o admin escolhe um cliente, age, volta e pega o proximo), e o estado dela - estrategia, filtro
 * de vendedor, pagina - nao vive na URL. Navegar na mesma aba jogaria tudo fora a cada clique.
 * Como ancora, tambem funcionam com clique do meio e ctrl+clique. Mesma escolha do drill do
 * PD-0006 (PredictAnalytics/DrillDrawer), que abre o cliente em aba nova.
 */
export const AcoesCelula = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`

export const AcaoLink = styled.a`
  display: inline-block;
  padding: 4px 12px;
  border-radius: 8px;
  border: 1px solid ${colors.secondary};
  background-color: ${colors.surface};
  color: ${colors.secondaryText};
  font-size: 12px;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;

  &:focus-visible {
    outline: 2px solid ${colors.secondary};
    outline-offset: 2px;
  }

  &:hover {
    background-color: ${colors.lightGreen};
  }
`
